import s from "./TourVideoGallery.module.scss";

const text = {
  JP: {
    kicker: "Tour Movie",
    title: "体験の雰囲気を動画で",
    lead: "写真だけでは伝わりにくい、秘境SUPツアーの空気感を動画でご覧ください。",
  },
  EN: {
    kicker: "Tour Movie",
    title: "See the Experience in Video",
    lead: "Watch the quiet hidden SUP atmosphere that photos alone cannot fully show.",
  },
  中文: {
    kicker: "Tour Movie",
    title: "用影片感受体验氛围",
    lead: "通过影片看看照片难以完全传达的秘境SUP氛围。",
  },
  한국어: {
    kicker: "Tour Movie",
    title: "영상으로 보는 체험 분위기",
    lead: "사진만으로는 전해지기 어려운 히든 SUP의 분위기를 영상으로 확인해보세요.",
  },
};

const normalizeVideo = (video, index) => {
  if (typeof video === "string") {
    return {
      src: video,
      title: `Tour movie ${index + 1}`,
      orientation: "landscape",
    };
  }

  return {
    title: `Tour movie ${index + 1}`,
    orientation: "landscape",
    ...video,
  };
};

const TourVideoGallery = ({ videos = [], language = "JP" }) => {
  const videoItems = Array.isArray(videos)
    ? videos.filter(Boolean).map(normalizeVideo)
    : [];
  const t = text[language] || text.JP;

  if (videoItems.length === 0) return null;

  return (
    <section className={s.root} aria-labelledby="tour-video-gallery-title">
      <div className={s.header}>
        <p className={s.kicker}>{t.kicker}</p>
        <h2 id="tour-video-gallery-title">{t.title}</h2>
        <p>{t.lead}</p>
      </div>

      <div className={s.scroller}>
        <div className={s.track}>
          {videoItems.map((video, index) => (
            <article
              className={`${s.card} ${
                video.orientation === "portrait" ? s.portrait : ""
              }`}
              key={`${video.src}-${index}`}
            >
              <video
                src={video.src}
                controls
                playsInline
                preload="metadata"
                aria-label={video.title}
              />

              {video.label && <p className={s.caption}>{video.label}</p>}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TourVideoGallery;
